// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2JPU0","item":"PaymentsMobile_item__12Qbr","label":"PaymentsMobile_label__1SUnf","amount":"PaymentsMobile_amount___a5a3"};